import { AddToCartState, ADD_FREE_PRODUCTS_TO_CART_SPEC, ADD_FREE_PRODUCTS_PUBLIC_DATA_KEYS } from './constants';
var AddToCartService = /** @class */ (function () {
    function AddToCartService(siteStore, publicData) {
        if (publicData === void 0) { publicData = {}; }
        var withExperiment = siteStore.experiments.enabled(ADD_FREE_PRODUCTS_TO_CART_SPEC);
        var isLegacy = publicData.APP && publicData.APP[ADD_FREE_PRODUCTS_PUBLIC_DATA_KEYS.ALLOW_FREE_PRODUCTS] === false;
        this.allowFreeProducts = withExperiment && !isLegacy;
    }
    AddToCartService.prototype.getButtonState = function (_a) {
        var price = _a.price, inStock = _a.inStock;
        if (!inStock) {
            return AddToCartState.OUT_OF_STOCK;
        }
        if (price === 0) {
            return this.allowFreeProducts ? AddToCartState.ENABLED : AddToCartState.DISABLED;
        }
        if (price < 0) {
            return AddToCartState.DISABLED;
        }
        return AddToCartState.ENABLED;
    };
    return AddToCartService;
}());
export { AddToCartService };
//# sourceMappingURL=AddToCartService.js.map